import * as m from '../paraglide/messages.js';

const AUTHENTICATION_MESSAGES = {
  'identity-provider-unavailable': m.identityProviderUnavailable(),
  'access-denied': m.accountAccessDenied(),
} as const;

type AuthenticationError = keyof typeof AUTHENTICATION_MESSAGES;

export function authenticationMessage(reason: string | null): string | undefined {
  return reason !== null && Object.hasOwn(AUTHENTICATION_MESSAGES, reason)
    ? AUTHENTICATION_MESSAGES[reason as AuthenticationError]
    : undefined;
}

export function consumeAuthenticationMessage(): string | undefined {
  const url = new URL(window.location.href);
  const message = authenticationMessage(url.searchParams.get('authError'));
  url.searchParams.delete('authError');
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
  return message;
}
